import { render, staticRenderFns } from "./modalArchivos.vue?vue&type=template&id=4f1e588d"
import script from "./modalArchivos.vue?vue&type=script&lang=js"
export * from "./modalArchivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports